<template>
	<div v-if="isLoadingCheck">
		<register-form	v-show="page == 'register_form'"
                    @onClicknext="onClicknext($event)">
    	</register-form>

		<register-term v-show="page == 'register_term'"
					view="register"
					@onClicknext="onClicknext($event)"
					:busModalTerm="busModalTerm">
		</register-term>

		<register-otp v-show="page == 'register_otp'"
					:lbl="lbl"
					:busOtpModal="busOtpModal"
					@initialOtpModal="initialOtpModal($event)"
					@onClicknext="onClicknext($event)">
		</register-otp>

		<modal view="register" :busModal="busModal" @modalAlertHidden="clickOkModalAlert($event)"></modal>
        <ModalBoutiqueID view="register" :busModal="busModalBoutiqueID" @modalBoutiqueIDHidden="clickOkModalBoutiqueID($event)"></ModalBoutiqueID>
	</div>
</template>
<script>


import Vue from "vue";

import RegisterForm from './components/RegisterForm.vue';
import RegisterTerm from './components/TermCompenent.vue';
import RegisterOtp from './components/OtpComponents.vue';

import OtpModel from "@/model/OtpModel.js";
import Locale from "@/helper/locale/locale.js";
import Account from "@/helper/AccountHelper.js";

import Modal from "@/components/modal/Modal.vue";
import ModalBoutiqueID from '../../components/modal/ModalBoutiqueID.vue'

import CacheHelper from "@/helper/CacheHelper.js";
import BzbsAuth from "@/service/BzbsAuth";
import Util from "@/helper/Utility.js"

export default {
    name: "Register",
    components: {
        RegisterForm,
        RegisterTerm,
        RegisterOtp,
        Modal,
        ModalBoutiqueID,
    },
    data: function () {
        return {
            lbl: Locale.getLbl(),

            isFirstSave: true,
            objUser: {},
            isLogin: false,

            objauthRequestOTPConfig: {},

            page: "register_form",
            busModal: new Vue(),
            busModalTerm: new Vue(),
            busOtpModal: new Vue(),
            busModalBoutiqueID: new Vue(),
            liffId: Vue.bzbsConfig.liffId,
            isLoadingCheck: false,


        };
    },
    created: async function () {
        if (await this.checkMaintenance()) {
            console.log("checkMaintenance TRUE")
            return
        }
        this.callApiFreelog()
       this.setUpregister();
    },
    mounted: function () {
       this.checkBoutiqueID()
    },
    methods: {

        callApiFreelog: function () {
            return new Promise((resolve) => {

                var date = new Date();
                var cacheHelper = new CacheHelper('cookie');

                var bid = cacheHelper.getCache('boutiqueId');
                var tmpUser = cacheHelper.getCache('TempID');

                if (!bid) {
                    bid = "NONE";
                    var fromSystm = cacheHelper.getCache('fromsystem', true);
                    if (fromSystm) {
                        bid = "SYSTEM";
                    }
                }

                var param = {
                    date: date,
                    BU: 'CHL',
                    Full: window.location.href,
                    STEP: 'Register Page',
                    appId: Vue.bzbsConfig.client_id,
                    boutiqueId: bid,
                    TempID: tmpUser,
                    UserID: Account.getCacheUser().userId,
                }
                BzbsAuth.apiFreeLog(param).then((res) => {

                        var cacheLocal = new CacheHelper('local');
                        cacheLocal.setCache('refKey', res.data.refKey);
                        cacheHelper.removeCache('fromsystem');

                        resolve();

                    }).catch(() => {
                        resolve();
                        // window.location.replace('/errorPage');
                    });
            })

        },
        setUpregister: function () {

            Account.loginStatus().then((status) => {
                if (!status) {
                    var boutiqueId = this.$route.query.boutiqueId;
                    Account.setCacheCustom("fromsystem", true);
                    if (boutiqueId) {
                        window.location.replace('/linelogin?boutiqueId='+boutiqueId);
                    } else {

                        window.location.replace('/linelogin');
                    }
                }
            });

        },

        onClicknext: async function (data) {
            if (data.tag == 'register_term') {
                var success = await this.checkBoutiqueID();
                if (success) {

                    this.page = 'register_term';
                    this.busModalTerm.$emit('setPhoneNumber',{ data : data});
                }
            } else if (data.tag == 'register_otp') {
                this.page = 'register_otp';
                this.objauthRequestOTPConfig = new OtpModel.AuthRequestOTPConfigModelBuilder().create();
                this.objauthRequestOTPConfig.strContactNumber = data.registerdata.data.contac_number;
                this.objauthRequestOTPConfig.strChannel = "Register";

                var registerdata = {
                    birthdate: data.registerdata.data.birthdate,
                    information: data.registerdata,
                    otpdata: this.objauthRequestOTPConfig
                }
                this.busOtpModal.$emit('showOtpModal',registerdata);
            } else if (data.tag == "register_form") {

                this.page = 'register_form';
            }
        },
        checkBoutiqueID: function () {
            return new Promise((resolve) => {
                Account.loginStatus().then((status) => {
                    this.isLogin = status;

                    if (this.isLogin == true) {
                        this.objUser = Account.getCacheUser();

                        if (this.objUser.userLevel > 0) {
                            var path = "/campaign";
                            this.$router.push(path);
                        } else {

                            let boutiqueIdCookie = Account.getCacheCustom("boutiqueId");

                            if (!boutiqueIdCookie) {
                                this.showAlertBoutiqueID()
                                resolve(false)
                            } else {
                                resolve(true)
                            }
                        }
                    } else {
                        let boutiqueIdCookie = Account.getCacheCustom("boutiqueId");

                        if (!boutiqueIdCookie) {
                            this.showAlertBoutiqueID()
                            resolve(false)
                        } else {
                            resolve(true)
                        }
                    }
                });
            });

            // this.busModalBoutiqueID.$emit("showModal");

		},
        showAlertBoutiqueID: function () {
            var configModal = {
                id: "register",
                title: null,
                message: this.lbl.register.mising_boutiqueID,
                strBtnOk: "ปิด",
            };
            this.busModalBoutiqueID.$emit("showModal", configModal);
        },
        clickOkModalBoutiqueID: function () {
            var url = Vue.bzbsConfig.linkSupport;
            if (Account.getCacheCustom("Formliff")) {
               window.JsFunction.openWeb(url);
            } else {
                window.location.replace(url)
            }
        },
        checkMaintenance: function () {
            console.log("checkMaintenance")
            let StartDateMaintenance = window.StartDateMaintenance;
            let EndDateMaintenance = window.EndDateMaintenance;
            // StartDateMaintenance = "2024-02-19 15:00:00"
            // EndDateMaintenance = "2024-02-19 15:08:00"
            if (Util.isEmptyStr(StartDateMaintenance) || Util.isEmptyStr(EndDateMaintenance)) {
                this.isLoadingCheck = true;
                console.log("checkMaintenance ISEMPTY")
                return false;
            } else {
                var stDate = new Date(StartDateMaintenance)
                var edDate = new Date(EndDateMaintenance)
                var today = new Date()
                if ( today > stDate && today < edDate)
                {
                    window.location.replace('/maintenance');
                    return true;
                }
                this.isLoadingCheck = true;
                return false;
            }
        }
    },
};
</script>
<style lang="scss" scoped>

</style>

